import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom"
import Footer from "../../Component/Footer";
import AdminHeader from "./AdminHeader";
import { useStateValue } from "../../Component/StateProviders";
import AdminLogin from "./AdminLogin";
import AdminSidebar from './AdminSidebar';
import Breadcrumb from "../../Component/Breadcrumb";
import Topbar from "../../Component/Topbar";
export default function AdminLayout() {

  const [{ DIsLogin }, dispatch] = useStateValue();
  let navigate = useNavigate();

  useEffect(() => {
    if (DIsLogin) {
      // navigate("/administration/dashboard");
    }
  }, [DIsLogin]);

  useEffect(() => {
    if (localStorage.getItem("DToken") !== null && localStorage.getItem("LoginDetails") === 'Admin') {
      dispatch({
        type: "DLogin",
      });
    } else {
      dispatch({
        type: "DLogout",
      });
    }
  }, []);
  return (<>
    <Topbar />
    <AdminHeader />
    {DIsLogin ?
      <>
        <Breadcrumb />
        <div className="slidebar_and_component">
          <AdminSidebar />
          <div className="outlet_main_div">
            <Outlet />
          </div>
        </div>
      </>
      : <AdminLogin />}
    <Footer />
  </>)
}